import { render, staticRenderFns } from "./WorkOrdersStatistics.vue?vue&type=template&id=1f8c6b9e&scoped=true"
import script from "./WorkOrdersStatistics.vue?vue&type=script&lang=js"
export * from "./WorkOrdersStatistics.vue?vue&type=script&lang=js"
import style0 from "./WorkOrdersStatistics.vue?vue&type=style&index=0&id=1f8c6b9e&prod&scoped=true&lang=scss"
import style1 from "./WorkOrdersStatistics.vue?vue&type=style&index=1&id=1f8c6b9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c6b9e",
  null
  
)

export default component.exports